import Loadable from '../../components/loadable';

const PaymentFailuresReport = Loadable({
  loader: () => import('../../pages/reports/payment_failures_report/payment_failures_report'),
});

angular.module('gym').value('PaymentFailuresReport', PaymentFailuresReport);

const PaymentFailuresReportFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/payment_failures_report/payment_failures_report_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('PaymentFailuresReportFiltersModal', PaymentFailuresReportFiltersModal);
